// client/src/pages/LostFoundList.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_API_URL}/api`;

export default function LostFoundList() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/lost-found`);
        const d = await res.json();
        setItems(d.items || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen p-6 bg-slate-50 dark:bg-slate-900">
      <div className="max-w-5xl mx-auto bg-white dark:bg-slate-800 p-6 rounded-xl shadow">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold dark:text-white">Lost & Found</h1>
          <div className="flex gap-2">
            <button onClick={() => navigate("/home")} className="px-3 py-1 border rounded dark:text-white">Back</button>
            <button onClick={() => navigate("/lost-found/create")} className="px-4 py-2 bg-indigo-600 text-white rounded">Post Item</button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-6">
          {loading ? (
            <div className=" dark:text-white">Loading…</div>
          ) : items.length === 0 ? (
            <div className="text-slate-600 dark:text-slate-300">No items posted yet.</div>
          ) : (
            items.map(item => (
              <div key={item._id} className="bg-slate-100 dark:bg-slate-900 p-4 rounded-lg shadow flex gap-4">
                <div className="w-28 h-20 bg-white rounded overflow-hidden">
                  {item.imageUrl ? (
                    <img src={item.imageUrl} alt="item" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-slate-400  dark:text-white">No</div>
                  )}
                </div>

                <div className="flex-1">
                  <h3 className="font-semibold dark:text-white">{item.title}</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">{item.description}</p>
                  <p className="text-xs text-slate-500 mt-2 dark:text-white">Location: {item.location || "N/A"}</p>
                  <p className="text-xs text-slate-500 dark:text-white">Posted by: {item.postedByName || "Someone"}</p>
                </div>

                <div className="flex flex-col gap-2">
                  <button onClick={() => navigate(`/lost-found/${item._id}`)} className="px-3 py-1 border rounded dark:text-white">
                    View
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
